import React from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export interface ISvgProps {
  svgIcon: string;
  width: number;
  height: number;
  viewBox?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  svg: {
    minWidth: '16px',
    maxWidth: '100%',
    maxHeight: '100%',
    height: 'auto',
    verticalAlign: 'middle',
    fill: 'currentColor',
    '& .gray-light': {
      fill: '#999999',
    },
    '& .gray': {
      fill: '#666666',
    },
    '& .gray-darker': {
      fill: '#262626',
    },
    '& .white': {
      fill: '#fff',
    },
    '& .brand-gray': {
      fill: '#252525',
    },
    '& .brand-primary': {
      fill: '#0BBBEF',
    },
    '& .brand-info': {
      fill: '#FFFF28',
    },
    '& .brand-success': {
      fill: '#80C53A',
    },
    '& .brand-danger': {
      fill: '#F92949',
    },
    '& .brand-warning': {
      fill: '#FE801E',
    },
  },
}));

export default function Svg(props: ISvgProps) {
  const classes = useStyles();
  const { svgIcon, width, height, viewBox } = props;
  return (
    <svg
      version="1.1"
      width={width}
      height={height}
      viewBox={viewBox || '0 0 32 32'}
      className={classes.svg}
      /* eslint-disable-next-line react/no-danger */
      dangerouslySetInnerHTML={{ __html: svgIcon }}
    />
  );
}
